import type { ComponentChildren } from "preact";

type ChipProps = {
  children?: ComponentChildren;
  active?: boolean;
  onClick?: () => void;
  class?: string;
};

export function Chip({ children, active, onClick, class: className }: ChipProps) {
  const cls = ["chip", active && "chip-active", className].filter(Boolean).join(" ");
  return (
    <button type="button" class={cls} onClick={onClick} aria-pressed={active}>
      {children}
    </button>
  );
}
